import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, TextInput, Textarea, Button, Title } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { useForm } from "@mantine/form";

const safeDate = (v) => {
  if (!v) return null;
  if (v instanceof Date) {
    return isNaN(v.getTime()) ? null : v;
  }
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
};

const ModalEditorGoal = ({ opened, onClose, onSave, goalData }) => {
  const { metas } = useSelector((state) => state.improvementPlan);
  const isEdit = Boolean(goalData?.Id);

  const form = useForm({
    initialValues: {
      titulo: goalData?.titulo ?? "",
      descripcion: goalData?.descripcion ?? "",
      fecha: safeDate(goalData?.fechaVencimiento),
    },
    validate: {
      titulo: (value) => (value.trim() ? null : "El título es obligatorio"),
      fecha: (value) => (value ? null : "La fecha de vencimiento es obligatoria"),
    },
  });

  useEffect(() => {
    if (opened) {
      form.setValues({
        titulo: goalData?.titulo ?? "",
        descripcion: goalData?.descripcion ?? "",
        fecha: safeDate(goalData?.fechaVencimiento),
      });
      form.resetDirty();
    }
  }, [opened, goalData?.Id]);

  const handleSubmit = () => {
    const res = form.validate();
    if (res.hasErrors) return;

    const d = form.values.fecha;
    const atMidnight = d
      ? new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0)
      : null;

    const saveGoal = {
      titulo: form.values.titulo,
      descripcion: form.values.descripcion,
      fechaVencimiento: atMidnight ? atMidnight.toISOString() : null,
      ...(isEdit ? { Id: goalData.Id } : {}),
    };

    onSave(saveGoal);
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Title fw={450} c="#E72166" size="28px">
          {isEdit ? "EDITAR META" : "CREAR META"}
        </Title>
      }
      centered
      size="lg"
    >
      <TextInput
        withAsterisk
        label="Título"
        description="Ingrese título de la meta"
        {...form.getInputProps("titulo")}
      />

      <DateInput
        locale="es"
        minDate={today}
        withAsterisk
        label="Fecha de vencimiento"
        {...form.getInputProps("fecha")}
        mt="md"
      />

      <Textarea
        label="Descripción"
        placeholder="Ingrese una descripción para la meta"
        {...form.getInputProps("descripcion")}
        mt="md"
        autosize
        minRows={2}
        maxRows={4}
      />

      <Button
        fullWidth
        mt="md"
        color="#E72166"
        onClick={handleSubmit}
        loading={metas?.saving}
      >
        Guardar
      </Button>
    </Modal>
  );
};

export default ModalEditorGoal;
